import React, { useContext } from "react";
import { BsCartX } from "react-icons/bs";
import { calculateTotal, displayMoney } from "../helpers/utils";
import useDocTitle from "../hooks/useDocTitle";
import cartContext from "../contexts/cart/cartContext";
import CartItem from "../components/cart/CartItem";
import EmptyView from "../components/common/EmptyView";

const Cart = () => {
  useDocTitle("Koszyk");
  const { cartItems } = useContext(cartContext);
  const cartQuantity = cartItems.reduce(
    (total, item) => total + item?.quantity,
    0
  );

  const cartTotal = cartItems.map((item) => item.price * item.quantity);
  const calculateCartTotal = calculateTotal(cartTotal);
  const displayCartTotal = displayMoney(calculateCartTotal);

  const cartDiscount = cartItems.map((item) => 0);
  const calculateCartDiscount = calculateTotal(cartDiscount);
  const displayCartDiscount = displayMoney(calculateCartDiscount);

  const totalAmount = calculateCartTotal - calculateCartDiscount;
  const displayTotalAmount = displayMoney(totalAmount);

  return (
    <section id="cart" className="section">
      <div className="container">
        {cartQuantity === 0 ? (
          <EmptyView
            icon={<BsCartX />}
            msg="Twój koszyk jest pusty"
            link="/all-products"
            btnText="Zacznij zakupy"
          />
        ) : (
          <div className="wrapper cart_wrapper">
            <div className="cart_left_col">
              {cartItems?.map((item) => (
                <CartItem key={item.id} {...item} />
              ))}
            </div>

            <div className="cart_right_col">
              <div className="order_summary">
                <h3>
                  Podsumowanie zamówienia &nbsp; ( {cartQuantity}{" "}
                  {cartQuantity > 1 ? "przedmioty" : "przedmiot"} )
                </h3>
                <div className="order_summary_details">
                  <div className="price">
                    <span>Cena początkowa</span>
                    <b>{displayCartTotal}</b>
                  </div>
                  {/* <div className="discount">
                    <span>Rabat</span>
                    <b>- {displayCartDiscount}</b>
                  </div> */}
                  <div className="delivery">
                    <span>Dostawa</span>
                    <b>Gratis</b>
                  </div>
                  <div className="separator"></div>
                  <div className="total_price">
                    <b>
                      <small>Cena całkowita</small>
                    </b>
                    <b>{displayTotalAmount}</b>
                  </div>
                </div>
                <button type="button" className="btn checkout_btn">
                  Przejdź do kasy
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Cart;
